import { render, staticRenderFns } from "./ViewerPage.vue?vue&type=template&id=3964364e&scoped=true&"
import script from "./ViewerPage.vue?vue&type=script&lang=js&"
export * from "./ViewerPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewerPage.vue?vue&type=style&index=0&id=3964364e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3964364e",
  null
  
)

export default component.exports